// Recently Viewed (P2.7) — localStorage only. No login, no server calls, no
// tracking infrastructure: the list lives entirely in the shopper's browser
// and can be cleared with normal browser storage.
const KEY = "gt_recently_viewed";
const MAX = 12;

export const recordView = (p, path) => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]").filter((i) => i.sku !== p.sku);
    list.unshift({
      sku: p.sku,
      title: p.seo_title || p.name,
      image: p.image_url,
      price: p.retail_price,
      path,
    });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* storage unavailable — feature quietly skips */
  }
};

export const getRecent = (excludeSku = null) => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]").filter((i) => i.sku !== excludeSku);
  } catch {
    return [];
  }
};
